module.exports = __webpack_public_path__ + "static/img/2911_phase_function_Paper_Points.b44e7a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2911_phase_function_Paper_Points.png
// module id = ELYL
// module chunks = 0